/* =========================================================
   ORION — theme.js
   Interactividad del tema + integración real con Ajax Cart API de Shopify
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Altura real del stack fijo (marquee + header) ----------
     Se mide de verdad en vez de asumir un número fijo, porque la altura
     cambia entre desktop/celular, con o sin marquee, y al hacer scroll. */
  var fixedStack = document.getElementById('fixedTopStack');
  function updateFixedStackHeight() {
    if (!fixedStack) return;
    var h = fixedStack.getBoundingClientRect().height;
    if (h > 0) {
      document.documentElement.style.setProperty('--fixed-stack-height', h + 'px');
    }
  }
  updateFixedStackHeight();
  window.addEventListener('resize', updateFixedStackHeight);
  // Las fuentes cargan de forma asíncrona y pueden cambiar la altura del header
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateFixedStackHeight);
  }
  window.addEventListener('load', updateFixedStackHeight);

  /* ---------- Selector de idioma ---------- */
  document.querySelectorAll('[data-lang-selector]').forEach(function (wrapper) {
    var form = wrapper.querySelector('form');
    var input = wrapper.querySelector('[data-locale-input]');
    wrapper.querySelectorAll('.lang-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('active')) return;
        input.value = btn.getAttribute('data-locale-code');
        form.submit();
      });
    });
  });

  /* ---------- Header scroll state ---------- */
  var header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 60);
      // el header encoge un poco al hacer scroll; recalculamos tras la transición
      setTimeout(updateFixedStackHeight, 360);
    }, { passive: true });
  }

  /* ---------- Overlay (compartido por carrito y menú móvil) ---------- */
  var overlay = document.getElementById('siteOverlay');
  var cartDrawer = document.getElementById('cartDrawer');
  var mobileMenu = document.getElementById('mobileMenu');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('open');
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('open');
  }
  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    overlay.classList.remove('open');
  }

  var cartToggle = document.getElementById('cartToggle');
  var cartClose = document.getElementById('cartClose');
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);

  var menuToggle = document.getElementById('menuToggle');
  var menuClose = document.getElementById('menuClose');
  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (menuClose) menuClose.addEventListener('click', closeMobileMenu);

  if (overlay) {
    overlay.addEventListener('click', function () {
      closeCart();
      closeMobileMenu();
    });
  }
  document.querySelectorAll('.mobile-menu a').forEach(function (link) {
  link.addEventListener('click', function (event) {
    var destination = link.getAttribute('href');

    if (!destination || destination === '#') {
      return;
    }

    event.preventDefault();
    closeMobileMenu();
    window.location.assign(destination);
  });
});
  /* ---------- Search toggle (header) ---------- */
  var searchToggle = document.getElementById('searchToggle');
  var searchBar = document.getElementById('searchBar');
  var searchInput = document.getElementById('searchInput');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      searchBar.classList.toggle('open');
      searchToggle.setAttribute('aria-expanded', searchBar.classList.contains('open'));
      if (searchBar.classList.contains('open') && searchInput) searchInput.focus();
    });
  }

  /* ---------- Product tabs (Destacados / Nuevos / Más vendidos) ---------- */
  document.querySelectorAll('[data-tab-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-tab-btn');
      document.querySelectorAll('[data-tab-btn]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      document.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-tab-panel') !== target;
      });
    });
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    var a = item.querySelector('.faq-a');
    if (!q || !a) return;
    if (item.classList.contains('open')) a.style.maxHeight = a.scrollHeight + 'px';
    q.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
        i.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
        i.querySelector('.faq-a').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('open');
        q.setAttribute('aria-expanded', 'true');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Testimonials carousel ---------- */
  var testiTrack = document.getElementById('testiTrack');
  if (testiTrack && testiTrack.children.length) {
    var testiIndex = 0;
    function testiCardsVisible() {
      var w = window.innerWidth;
      if (w <= 640) return 1;
      if (w <= 980) return 2;
      return 3;
    }
    function updateTesti() {
      var total = testiTrack.children.length;
      var visible = testiCardsVisible();
      var maxIndex = Math.max(0, total - visible);
      testiIndex = Math.min(testiIndex, maxIndex);
      var cardWidth = testiTrack.children[0].getBoundingClientRect().width + 22;
      testiTrack.style.transform = 'translateX(-' + (testiIndex * cardWidth) + 'px)';
    }
    var next = document.getElementById('testiNext');
    var prev = document.getElementById('testiPrev');
    if (next) next.addEventListener('click', function () {
      var total = testiTrack.children.length;
      var visible = testiCardsVisible();
      var maxIndex = Math.max(0, total - visible);
      testiIndex = Math.min(testiIndex + 1, maxIndex);
      updateTesti();
    });
    if (prev) prev.addEventListener('click', function () {
      testiIndex = Math.max(testiIndex - 1, 0);
      updateTesti();
    });
    window.addEventListener('resize', updateTesti);
    updateTesti();
  }

  /* ---------- Ember dividers: animar al entrar en pantalla ---------- */
  if ('IntersectionObserver' in window) {
    var emberObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('in-view');
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-ember]').forEach(function (el) { emberObserver.observe(el); });
  }

  /* ---------- Favoritos (localStorage, solo del lado del cliente) ---------- */
  var FAV_KEY = 'orion_favorites';
  function getFavorites() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; }
  }
  function setFavorites(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) { /* no-op */ }
  }
  function paintFavorites() {
    var favs = getFavorites();
    document.querySelectorAll('[data-fav-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-fav-id');
      btn.classList.toggle('active', favs.indexOf(id) > -1);
    });
  }
  document.addEventListener('click', function (e) {
    var favBtn = e.target.closest('[data-fav-toggle]');
    if (!favBtn) return;
    e.preventDefault();
    var id = favBtn.getAttribute('data-fav-id');
    var favs = getFavorites();
    var idx = favs.indexOf(id);
    if (idx > -1) { favs.splice(idx, 1); } else { favs.push(id); }
    setFavorites(favs);
    paintFavorites();
  });
  paintFavorites();

  /* =========================================================
     CARRITO — Ajax Cart API real de Shopify
     ========================================================= */

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-cart-count', count);
    });
  }
  function updateSubtotal(moneyString) {
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = moneyString;
    });
  }

  // Shopify expone Shopify.formatMoney si moneyFormat está configurado; si no, formato simple.
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return (window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active + ' ' : '$') + amount;
  }

  // Re-render simple de las líneas del carrito (usado tras add/change/remove)
  function renderCartItemsFallback(cart) {
    var containers = document.querySelectorAll('[data-cart-items]');
    if (!containers.length) return;

    containers.forEach(function (container) {
      if (cart.item_count === 0) {
        container.innerHTML = '<div class="cart-empty">' +
          '<p>Tu carrito está vacío.<br>Explora la colección y agrega tu ritual.</p></div>';
        return;
      }
      var html = '';
      cart.items.forEach(function (item) {
        html += '<div class="cart-item" data-cart-line-key="' + item.key + '">' +
          '<div class="cart-item-media">' + (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" width="64" height="76" loading="lazy">' : '') + '</div>' +
          '<div class="cart-item-info">' +
          '<h5>' + escapeHtml(item.product_title) + '</h5>' +
          (item.variant_title ? '<span class="variant-title">' + escapeHtml(item.variant_title) + '</span>' : '') +
          '<span class="price">' + formatMoney(item.final_price) + '</span>' +
          '<div class="qty-row">' +
          '<button type="button" data-cart-qty-decrease data-key="' + item.key + '" aria-label="Reducir cantidad">−</button>' +
          '<span data-cart-qty-value>' + item.quantity + '</span>' +
          '<button type="button" data-cart-qty-increase data-key="' + item.key + '" aria-label="Aumentar cantidad">+</button>' +
          '</div>' +
          '<button type="button" class="remove-btn" data-cart-remove data-key="' + item.key + '">Eliminar</button>' +
          '</div></div>';
      });
      container.innerHTML = html;
    });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateSubtotal(formatMoney(cart.total_price));
        renderCartItemsFallback(cart);
        openCart();
      })
      .catch(function (err) {
        alert((err && err.description) || 'No pudimos agregar el producto. Intenta de nuevo.');
      });
  }

  function changeCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateSubtotal(formatMoney(cart.total_price));
        renderCartItemsFallback(cart);
      });
  }

  // Delegación de eventos: quick add (tarjetas de producto)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add-form]');
    if (!form) return;
    e.preventDefault();
    var variantId = form.getAttribute('data-variant-id');
    var btn = form.querySelector('.quick-add');
    var originalText = btn.textContent;
    btn.textContent = 'Agregando…';
    addToCart(variantId, 1).finally(function () { btn.textContent = originalText; });
  });

  // Delegación de eventos: +/- y eliminar dentro del carrito (drawer y página completa)
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-cart-qty-decrease]');
    var inc = e.target.closest('[data-cart-qty-increase]');
    var rem = e.target.closest('[data-cart-remove]');

    if (dec) {
      var key1 = dec.getAttribute('data-key');
      var span1 = dec.parentElement.querySelector('[data-cart-qty-value]');
      var qty1 = Math.max(0, parseInt(span1.textContent, 10) - 1);
      changeCartLine(key1, qty1);
    }
    if (inc) {
      var key2 = inc.getAttribute('data-key');
      var span2 = inc.parentElement.querySelector('[data-cart-qty-value]');
      var qty2 = parseInt(span2.textContent, 10) + 1;
      changeCartLine(key2, qty2);
    }
    if (rem) {
      changeCartLine(rem.getAttribute('data-key'), 0);
    }
  });

  /* =========================================================
     PÁGINA DE PRODUCTO — selector de variantes y cantidad
     ========================================================= */
  var productForm = document.getElementById('productForm');
  if (productForm) {
    var variantsDataEl = document.getElementById('ProductVariants');
    var variants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];
    var selectedOptions = [];

    // Inicializar selectedOptions con la variante actualmente seleccionada
    var currentVariantId = productForm.querySelector('[data-variant-select]').value;
    var currentVariant = variants.filter(function (v) { return String(v.id) === String(currentVariantId); })[0];
    if (currentVariant) selectedOptions = [currentVariant.option1, currentVariant.option2, currentVariant.option3];

    function findVariant() {
      return variants.filter(function (v) {
        return v.option1 == selectedOptions[0] && v.option2 == selectedOptions[1] && v.option3 == selectedOptions[2];
      })[0];
    }

    productForm.querySelectorAll('[data-option-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-option-value');
        selectedOptions[index] = value;

        // marcar activo dentro de su grupo de opciones
        var group = btn.closest('.option-values');
        group.querySelectorAll('.option-value').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        var match = findVariant();
        if (match) {
          productForm.querySelector('[data-variant-select]').value = match.id;
          var submitBtn = productForm.querySelector('[data-add-to-cart]');
          if (match.available) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Agregar al carrito — ' + formatMoney(match.price);
          } else {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Agotado';
          }
        }
      });
    });

    var qtyInput = productForm.querySelector('[data-qty-input]');
    var qtyDec = productForm.querySelector('[data-qty-decrease]');
    var qtyInc = productForm.querySelector('[data-qty-increase]');
    if (qtyDec) qtyDec.addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    });
    if (qtyInc) qtyInc.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = productForm.querySelector('[data-variant-select]').value;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      var submitBtn = productForm.querySelector('[data-add-to-cart]');
      var original = submitBtn.textContent;
      submitBtn.textContent = 'Agregando…';
      addToCart(variantId, qty).finally(function () { submitBtn.textContent = original; });
    });

    // Galería: cambiar imagen principal al hacer clic en una miniatura
    document.querySelectorAll('[data-full-img]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mainImg = document.getElementById('mainProductImage');
        if (mainImg) mainImg.src = thumb.getAttribute('data-full-img');
      });
    });
  }

});

/* ORION — corregir enlace Kids & Teens */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a').forEach(function (link) {
    var label = link.textContent.trim().toLowerCase();

    if (
      label === 'kids & teens' ||
      label === 'kids and teens' ||
      label === 'niños y adolescentes'
    ) {
      link.setAttribute('href', '/collections/kids');
    }
  });
});